export default __webpack_public_path__ + "static/media/_ic_back.8a6d9c3e.svg";